import type { ModuleCode } from '../../features/modules/modules';
import apiClient from '../index';

export const getClients = async (module: ModuleCode) => {
	const response = await apiClient.get(
		`/clients?${new URLSearchParams({ module })}`,
	);
	return response.data;
};

export const getClientFiles = async (clientId: string, module: ModuleCode) => {
	const response = await apiClient.get(
		`/files?${new URLSearchParams({ clientId, module })}`,
	);
	return response.data;
};

/** `filterQuery` is the filter's query string; the module is added to it. */
export const getCanonicalRowPreview = async (
	clientId: string,
	module: ModuleCode,
	filterQuery: string,
) => {
	const params = new URLSearchParams(filterQuery);
	params.set('module', module);
	const response = await apiClient.get(
		`/clients/${clientId}/canonical-rows/preview?${params}`,
	);
	return response.data;
};
